
import { EventEmitter } from "events"

const ee = new EventEmitter()

// sign_in
ee.on("sign_in:success", () => {
  ee.emit("sign_in:success:action")
})

type sign_in_error = "password" | "username"
ee.on("sign_in:error", (msg?: sign_in_error) => {
  ee.emit("sign_in:error:action", msg)
})


// sign_up
ee.on("sign_up:success", () => {
  ee.emit("sign_up:success:action")
})


// forgot_password
ee.on("forgot_password:success", () => {
  ee.emit("forgot_password:success:action")
})

ee.on("forgot_password:error", () => {
  ee.emit("forgot_password:error:action")
})


export default ee
